/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React from 'react'
import {
  VerticalTimeline,
  VerticalTimelineElement
} from 'react-vertical-timeline-component'
import 'react-vertical-timeline-component/style.min.css'
import './styles.scss'
import { timelineContent } from './timelineContent'

const isMobile = window.innerWidth < 320

export function Timeline() {
  return (
    <div id='timeline'>
      <VerticalTimeline layout='2-columns' animate={false}>
        {timelineContent.map((c, index) => (
          <React.Fragment key={index}>{c.step}</React.Fragment>
        ))}
      </VerticalTimeline>
    </div>
  )
}
